/* Parse redirect URL and validate against the configured ACS URL.
  Invalid or malformed URLs are handled by returning null
*/
export function tryParseUrl(url: string): URL | null {
  try {
    return new URL(url);
  } catch {
    return null;
  }
}

/*constructs an allowlist of trusted redirect origins
  from the configured SSO callback URLs
*/
export function buildTrustedSsoRedirectOrigins(
  ...candidates: Array<string | undefined | null>
): Set<string> {
  const origins = new Set<string>();

  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }

    const parsed = tryParseUrl(candidate);
    if (parsed) {
      origins.add(parsed.origin);
    }
  }

  return origins;
}

export function isTrustedSsoRedirectOrigin(
  url: URL,
  trustedOrigins: ReadonlySet<string>
): boolean {
  return trustedOrigins.has(url.origin);
}

/**
 * Validates SSO exchange token against the format produced by the ACS endpoint
 * Expected format: exactly 64 uppercase hexadecimal characters (A-F, 0-9).
 *
 * Length pre-checks run before the regex to short-circuit obviously invalid values:
 *   - Min 10: rejects empty and trivially short inputs.
 *   - Max 2048: rejects oversized payloads that could indicate an injection attempt.
 */
export function isValidSsoExchangeToken(token: string): boolean {
  if (!token || token.length < 10 || token.length > 2048) {
    return false;
  }

  // 64 uppercase hexadecimal characters (A-F, 0-9).
  return /^[A-F0-9]{64}$/.test(token);
}
